
require('./sca.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @components
const ScaRequestModal = require('components/sca/scaRequestModal/scaRequestModal');

// @helpers
const { getPhoneNumber } = require('utilities/personalDataHelper');


class ScaDownloadMovements extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const {scaRequiredForDownloadTransactions} = nextProps;
        const { isVisible } = prevState;
        return scaRequiredForDownloadTransactions === true && !isVisible?  {isVisible:true} :  null;
    }

    constructor(props) {
        super(props);
        this.state = { isVisible: false };

        this.buildModalsSection = this.buildModalsSection.bind(this);
        this.handlePrimaryButtonScaRequestClick = this.handlePrimaryButtonScaRequestClick.bind(this);
        this.handleToggleScaRequestModal = this.handleToggleScaRequestModal.bind(this);
    }
    
    buildModalsSection(loading) {
        const { immProfile } = this.props;
        const { isVisible } = this.state;
        const phoneNumber = getPhoneNumber(immProfile);
 
        return (
            <React.Fragment>
                {
                    isVisible && 
                    <ScaRequestModal
                        loading={loading}
                        visible={isVisible}
                        onCloseCallback={this.handleToggleScaRequestModal}
                        onPrimaryButtonClick={this.handlePrimaryButtonScaRequestClick}
                        phone={phoneNumber}
                    />
                }
                
            </React.Fragment>
        )
    }

    handlePrimaryButtonScaRequestClick() {
        const { onHandlePostRequest, validateAndExecuteSagas } = this.props;
        validateAndExecuteSagas(() => onHandlePostRequest())
    }


    handleToggleScaRequestModal() {
        const { isVisible } = this.state;
        const { resetScaForAccountTransactionsDownload } = this.props;
        resetScaForAccountTransactionsDownload();
        this.setState({ isVisible: !isVisible });
    }

    render() {
        const { immTransactions, scaRequiredForDownloadTransactions } = this.props;
        const loading = !immTransactions || immTransactions.get('loading');
        if (!scaRequiredForDownloadTransactions) return null;

        const modalsSection = this.buildModalsSection(loading);

        return (
            <React.Fragment>
                {modalsSection}
            </React.Fragment>
        );
    }
}

ScaDownloadMovements.propTypes = {
    onHandlePostRequest: PropTypes.func.isRequired,
    resetScaForAccountTransactionsDownload: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    immTransactions: PropTypes.object,
    validateAndExecuteSagas: PropTypes.func.isRequired,
    scaRequiredForDownloadTransactions: PropTypes.bool
};

module.exports = ScaDownloadMovements;
